import React from "react";
import Phonebook from "@/components/Phonebook";
import { useReference } from "@/lib/useReference";

export default function AdminPhonebook() {
  const { ref } = useReference();
  return <Phonebook endpoint="/admin/contacts" title="Phonebook" subtitle="These contacts are pinned to the top of every coach's phonebook in the selected district." districts={ref.districts} pageSize={10} />;
}
